<template>
  <div class="notfound">
  </div>
</template>
  
<script>
export default {
  data() {
    return {};
  },
};
</script>
  
<style>
.notfound {
  height: 100%;
  background-image: url('../assets/img/2696448-01.png');
  background-size:600px auto;
  background-position: center;
  background-repeat: no-repeat;
}
</style>